import { render, staticRenderFns } from "./RichTextVideo.vue?vue&type=template&id=72165328&scoped=true&"
import script from "./RichTextVideo.vue?vue&type=script&lang=js&"
export * from "./RichTextVideo.vue?vue&type=script&lang=js&"
import style0 from "./RichTextVideo.vue?vue&type=style&index=0&id=72165328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72165328",
  null
  
)

export default component.exports